import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { GlobalServiceProvider } from '../providers/global-service';
import { App } from 'ionic-angular';
// import { RepresentadaModel } from '../models/representada-model';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {

  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  pages: Array<{ title: string, component: any, icon: any, color: string }>;
  // representadas: Array<RepresentadaModel>;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public storage: Storage,
    public app: App, public alertCtrl: AlertController, public global: GlobalServiceProvider) {

    this.initializeApp();

        storage.get('accessUser').then((value) => {

          if (value == null) {

            this.rootPage = 'LoginPage';

          } else {

            global.setUserPass(value.username + ':' + value.password);
            global.setEmpresa(value.empresa + ',' + value.filial);

            if (value.login) {

              this.rootPage = 'HomePage';
              // this.usuario = value;
              global.usuario = value;

              // storage.get('representada').then((value) => {

              //   // this.representadas = value;
              //   // global.representadas = value;

              //   if (global.representadas.length > 0) {

              //     if (global.usuario.repcodigo === "" || global.usuario.repcodigo === undefined) {

              //       global.usuario.repcodigo = global.representadas[0].REP_CODIGO;
              //       global.representada = global.representadas[0];
              //       this.storage.set('accessUser', this.global.usuario);

              //     } else {

              //       this.representadas = global.representadas.filter((item) => {
              //         return (item.REP_CODIGO.toLowerCase().indexOf(global.usuario.repcodigo.toLowerCase()) > -1);
              //       })

              //       global.representada = this.representadas[0];

              //     }
              //   }

              // });

              //--------------------------------------
              // CARREGA OS PARAMETROS
              //--------------------------------------
              storage.get('parametro').then((value) => {

                global.parametros = value;

              });

            } else {

              this.rootPage = 'LoginPage';

            }

          }

        }).catch(() => this.rootPage = 'LoginPage');

    platform.ready().then(() => {

      statusBar.styleDefault();
      statusBar.backgroundColorByHexString('#ffff');
      splashScreen.hide();

    });

    this.pages = [
      { title: 'Indicadores', component: 'HomePage', icon: 'pie', color: 'primary' },
      { title: 'Localizar', component: 'LocalizarPage', icon: 'search', color: 'primary' },
      { title: 'Logout', component: 'LoginPage', icon: 'log-out', color: 'primary' }
    ];

  }


  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
    this.platform.registerBackButtonAction(() => {
      // Catches the active view
      let nav = this.app.getActiveNavs()[0];
      let activeView = nav.getActive();
      // Checks if can go back before show up the alert
      if (activeView.name === 'HomePage' ||
        activeView.name === 'LocalizarPage' ||
        activeView.name === 'LoginPage') {
        if (nav.canGoBack()) {
          nav.pop();
        } else {
          const alert = this.alertCtrl.create({
            title: 'Encerrar o Wms+',
            message: 'Tem certeza que deseja fechar o aplicativo?',
            buttons: [{
              text: 'Cancelar',
              role: 'cancel',
              handler: () => {
                this.nav.setRoot(activeView.name);
                console.info('Saída do App Cancelada!');
              }
            }, {
              text: 'Encerrar',
              handler: () => {
                // this.logout();
                this.platform.exitApp();
              }
            }]
          });
          alert.present();
        }
      }
    });
  }

  openPage(page) {
    this.nav.setRoot(page.component);
  }

  // doChangeRep(value) {

  //   this.representadas = this.global.representadas.filter((item) => {
  //     return (item.REP_CODIGO.toLowerCase().indexOf(this.global.usuario.repcodigo.toLowerCase()) > -1);
  //   })

  //   this.global.representada = this.representadas[0];

  //   this.global.usuario.repcodigo = value;
  //   this.storage.set('accessUser', this.global.usuario);

  // }


}




// WEBPACK FOOTER //
// ./src/app/app.component.ts